import { CreateReCustomQuotationBoDto, GetOneExpeditionBoResponseDto } from "@/types/api/api-types";
import { ReCustomQuotationFormData } from "@/components/backOffice/pendingCustomQuotation/customQuotationQuote.form";

type PropsReCustomQuotation = {
  expedition: GetOneExpeditionBoResponseDto;
  data: ReCustomQuotationFormData;
};

export const createReCustomQuotationPayload = ({
  expedition,
  data,
}: PropsReCustomQuotation): CreateReCustomQuotationBoDto => {
  const reference = "RE-EXP-D-" + expedition.customQuotation?.identifier;

  return {
    customId: data.invoiceData.customId,
    invoiceData: {
      client: data.invoiceData.client,
      customId: data.invoiceData.customId,
      transportHt: data.invoiceData.transportHt * 100,
      packaging: data.invoiceData.packaging * 100,
      packagingProtection: data.invoiceData.packagingProtection * 100,
      taxes: data.invoiceData.taxes * 100,
      insurance: data.invoiceData.insurance * 100,
      tva: data.invoiceData.tva * 100,
      reference: data.invoiceData.reference || reference,
    },
    type: expedition.customQuotation!.type!,
    express: data.express,
    insurance: data.insurance,
    reference: data.reference || reference,
    billingEntityId: data.billingEntityId,
    otherCustomQuotationType: data.otherCustomQuotationType,
    parcelCotation: {
      parcelCount: data.parcelProducts?.length || 0,
      parcelProducts:
        data.parcelProducts?.map((product) => ({
          type: product.type,
          description: product.description || null,
          volume: product.volume || null,
          bottleQuantity: product.bottleQuantity || null,
        })) || [],
      parcelPackages: data.parcelPackages || [],
    },
    paletteCotation: {
      paletteProducts: data.paletteProducts || [],
      palettePackages: data.palettePackages || [],
    },
    otherNumberOfExpedition:
      data.deliveryInfo.singleDelivery === false
        ? data.deliveryInfo.otherNumberOfExpedition || 1
        : undefined,
    pickupLastName: data.pickupInfo.manualPickup ? data.pickupInfo.pickupLastName : undefined,
    pickupFirstName: data.pickupInfo.manualPickup ? data.pickupInfo.pickupFirstName : undefined,
    pickupPhone: data.pickupInfo.manualPickup ? data.pickupInfo.pickupPhone : undefined,
    pickupCompany: data.pickupInfo.manualPickup ? data.pickupInfo.pickupCompany : undefined,
    pickupStreet: data.pickupInfo.manualPickup ? data.pickupInfo.pickupStreet : undefined,
    pickupPostalCode: data.pickupInfo.manualPickup ? data.pickupInfo.pickupPostalCode : undefined,
    pickupCity: data.pickupInfo.manualPickup ? data.pickupInfo.pickupCity : undefined,
    pickupCountry: data.pickupInfo.manualPickup ? data.pickupInfo.pickupCountry : undefined,
    pickupLocationId: data.pickupInfo.manualPickup ? undefined : data.pickupInfo.pickupLocationId,
    deliveryLastName: data.deliveryInfo.singleDelivery
      ? data.deliveryInfo.deliveryLastName
      : undefined,
    deliveryFirstName: data.deliveryInfo.singleDelivery
      ? data.deliveryInfo.deliveryFirstName
      : undefined,
    deliveryPhone: data.deliveryInfo.singleDelivery ? data.deliveryInfo.deliveryPhone : undefined,
    deliveryEmail: data.deliveryInfo.singleDelivery ? data.deliveryInfo.deliveryEmail : undefined,
    deliveryCompany: data.deliveryInfo.singleDelivery
      ? data.deliveryInfo.deliveryCompany
      : undefined,
    deliveryStreet: data.deliveryInfo.singleDelivery ? data.deliveryInfo.deliveryStreet : undefined,
    deliveryAdditionalInfo: data.deliveryInfo.singleDelivery
      ? data.deliveryInfo.deliveryAdditionalInfo
      : undefined,
    deliveryAdditionalInfo2: data.deliveryInfo.singleDelivery
      ? data.deliveryInfo.deliveryAdditionalInfo2
      : undefined,
    deliveryPostalCode: data.deliveryInfo.singleDelivery
      ? data.deliveryInfo.deliveryPostalCode
      : undefined,
    deliveryCity: data.deliveryInfo.singleDelivery ? data.deliveryInfo.deliveryCity : undefined,
    note: data.note,
    basedOnId: data.basedOnId,
    skipPickup: data.skipPickup,
    transportDiscountPercentage: data.transportDiscountPercentage,
    overallDiscountPercentage: data.overallDiscountPercentage,
  };
};
